import { createResource } from '../../shared/lib/createResource';
import graphqlQuery from './GraphQLQuery';

const HomeResource = createResource(
  (artistId: string) =>
    graphqlQuery(artistId).then(response => {
      if (response.data) {
        return response;
      }
      throw new Error('Error loading home data');
    }), // when key changes the loader is called again
);

/* eslint-disable-next-line import/no-default-export */
export default HomeResource;
